export default "__VITE_ASSET__48868237__"